import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "./../Components/Base/CustomButton";
import InputTextBox from "./../Components/Base/InputTextBox";
import Loader from "./../Components/Loder";
import ToolBar from "./../Components/ToolBar/ToolBar";
import AppContext from "./../Context/AppContext";
import { RestReportBean } from "./../Ds/client_ds";
import PageBar from "./../Components/ToolBar/PageBar";
import {
  SalesOrderSearchCriteria,
  RestEntityPrintRequest,
  RestLogisticOrderReceiptListRequest,
  RestReadRequest,
  PageListBean,
  RestSalesOrderListRequest,
  RestInvoiceListRequest,
} from "./../Ds/ds";
import service from "./../Services/Service";
import DatePicker from"./../Components/Base/DatePicker";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_WARN,
} from "./../Utils/appConstants";
import {
  ColumnDefinition,
  isEmpty,
  isEmptyArray,
  isEmptyString,
  StatusConvertor,
} from "./../Utils/util";
import InValidAccess from "./../Components/InValidAccess";
import { SecurityAccessManager } from "./../Security/SecurityAccessManager";
import { EXCELICON, MOREOPTIONICON, PDFICON } from "./../Utils/icons";
import Modal from "./../Components/Modal";
import CustomTable from "./../Components/Base/CustomTable";
import ViewToggle from "./../Components/ViewToggle";
import MobileCardTable from "./../Components/MobileCardTable";

// ─────────────────────────────────────────────────────────────────────
// SalesOrder line detail modal content
// ─────────────────────────────────────────────────────────────────────
const SalesOrderDetails = ({ salesOrderData }) => {
  const Columns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)
        .setStyleDetails("left", "7", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "7", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "4", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "openQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true)
        .setStyleDetails("left", "2", "", "wt-3", "wt-3")
        .setStatusDetails(true, getCaption)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Disc%", "discountPercentage", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("DiscAmt", "lineDiscountAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return _columns;
  };

  const getCaption = (status) => StatusConvertor(4, status);

  return (
    <div className="model-fw">
      <CustomTable columns={Columns} data={salesOrderData.lines} />
    </div>
  );
};


// ─────────────────────────────────────────────────────────────────────
// Main component
// ─────────────────────────────────────────────────────────────────────
export default function SalesOrderMaintenance() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [dataList, setDataList] = useState([]);
    const [invdataList, setInvDataList] = useState([]);

  const [criteria, setCriteria] = useState(new SalesOrderSearchCriteria());

  const title = "DashBoard";

  // ── Filter state ──

  const [customerCode, setCustomerCode] = useState("");
  // ── Pagination / UI state ──
  const [page, setPage]               = useState(1);
  const [pageSize]                    = useState(5);
  const [maxPage, setMaxPage]         = useState(1);
  const [totalCount, setTotalCount]   = useState(0);
  const [isLoading, setIsLoading]     = useState(false);
  const [isShowPdf, setIsShowPdf]     = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable]         = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);
  const [isShowModal, setIsShowModal]   = useState(false);
  const [salesOrderData, setSalesOrderData] = useState({});
  const [view, setView]               = useState(1); // 1 = list, 2 = grid

  // ── Mobile filter sheet ──
  const [isMobile, setIsMobile]         = useState(window.innerWidth <= 768);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const isEntityUser = !isEmptyString(session?.entityCode);


  const [isFullscreen, setFullscreen] = useState(false);
  const inputRef  = useRef(null);
  const buttonRef = useRef(null);
  const criteriaRef = useRef(null);

  // Tracks whether the sales-order list and the invoice list have each
  // finished loading, so the loading spinner only turns off once BOTH have
  // completed — not right after just one of them responds.
  const isSalesOrderLoadedRef = useRef(false);
  const isInvoiceLoadedRef = useRef(false);

  // ── Lifecycle ──
  useEffect(() => {
    setFocus();
    asignDefault();
    loadPage(1);
  }, []);

  useEffect(() => {
    function handleResize() {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Only auto-switch view on resize; let the manual toggle
      // (listViewHandler / gridViewHandler) win otherwise.
      setView((prevView) => (mobile ? 2 : prevView === 2 ? 1 : prevView));
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ── Helpers ──
  const setFocus = () => { if (inputRef.current) inputRef.current.focus(); };

  const notify = (type, msg, theme) => {
    if (type === 1) toast.info(msg, { theme });
    else if (type === 2) toast.error(msg, { theme });
    else if (type === 3) toast.success(msg, { theme });
    else if (type === 4) toast.warn(msg, { theme });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };

  // Turns off the loading spinner only once both the sales-order list and the
  // invoice list have finished loading.
  const stopLoadingWhenBothDone = () => {
    if (isSalesOrderLoadedRef.current && isInvoiceLoadedRef.current) {
      setIsLoading(false);
    }
  };

  const asignDefault = () => {
    const _criteria = new SalesOrderSearchCriteria();
    _criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode } = session;
      if (!isEmptyString(entityCode)) {
        _criteria.customerCode = entityCode;
        setCustomerCode(entityCode);
      }
    }
    criteriaRef.current = _criteria;
    setCriteria(_criteria);
  };



  // ── Response handlers ──
  const handleSalesOrderDetailsResponse = (response) => {
    let msg = "";
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmpty(response.data.salesOrder)) {
          setSalesOrderData(response.data.salesOrder);
          setIsShowModal(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };



const onCriteriaChange = (e) => {
  const { name, value } = e.target;

  const updated = {
    ...criteriaRef.current, // ✅ correct source
    [name]: value,
  };

  criteriaRef.current = updated;
  setCriteria(updated);
};
// const clearCriteriaAll = () =>{
// let criteria = new ()
//   setCriteria()

// }
  const handleReportResponse = (response) => {
    let msg_List = [];
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                response.data.reportResult.reportFileID
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  const handleResponse = (response) => {
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.sessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.success) {
        if (
          !isEmpty(response.data.salesOrderPageList) &&
          !isEmptyArray(response.data.salesOrderPageList.salesOrders)
        ) {
          setDataList(response.data.salesOrderPageList.salesOrders);
          if (response.data.salesOrderPageList.totalCount != null) {
            const total_Count = response.data.salesOrderPageList.totalCount;
            setTotalCount(total_Count);
            setMaxPage(Math.ceil(total_Count / pageSize));
          }
          if (response.data.salesOrderPageList.currentPage != null) {
            setPage(response.data.salesOrderPageList.currentPage);
          }
          if (!isEmptyArray(response.data.infos)) {
            response.data.infos.map((info) => msg_List.push(info.messageDescription));
          }
        }
        if (
          !isEmpty(response.data.salesOrderPageList) &&
          isEmptyArray(response.data.salesOrderPageList.salesOrders)
        ) {
          if (!isEmptyArray(response.data.errors)) {
            response.data.errors.map((error) => msg_List.push(error.messageDescription));
            notify(TOAST_ERROR, msg_List.toString());
          } else {
            notify(TOAST_WARN, "No Data Found");
          }
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    isSalesOrderLoadedRef.current = true;
    stopLoadingWhenBothDone();
  };

  // ── API calls ──
  const loadPage = (id) => {
  

    // Reset the "finished loading" flags for this new load cycle so the
    // spinner stays on until both calls below have come back.
    isSalesOrderLoadedRef.current = false;
    isInvoiceLoadedRef.current = false;

    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      setDataList([]);
      setIsLoading(true);
      const request = new RestSalesOrderListRequest();
     
      request.searchCriteria = criteriaRef.current;
      const pageInput = new PageListBean();
      pageInput.currentPage = id;
      pageInput.pageSize = pageSize;
      request.pageInput = pageInput;
      service(token, "getSalesOrderPageList", request, handleResponse, errorCallBack);
    } else {
      setIsAccessible(true);
      // The sales-order call never fires in this branch, so it will never
      // "complete" on its own — treat it as already done so the invoice
      // response alone can still turn off the loading spinner.
      isSalesOrderLoadedRef.current = true;
    }


        
        setInvDataList([]);
        setIsLoading(true);
        const request = new RestInvoiceListRequest();
        request.searchCriteria = criteriaRef.current;
        const pageInput = new PageListBean();
        pageInput.currentPage = id;
        pageInput.pageSize = pageSize;
        request.pageInput = pageInput;
     
        
        service(token, "getInvoicePageList", request, handleResponsInvoice, errorCallBack);
      
  };

  
  const handleResponsInvoice = (response) => {
   
    
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.invoicePageList) &&
          !isEmptyArray(response.data.invoicePageList.invoices)
        ) {
          setInvDataList(response.data.invoicePageList.invoices);
          if (response.data.invoicePageList.totalCount != null) {
            const total_Count = response.data.invoicePageList.totalCount;
            setTotalCount(total_Count);
            setMaxPage(Math.ceil(total_Count / pageSize));
          }
          if (response.data.invoicePageList.currentPage != null) {
            setPage(response.data.invoicePageList.currentPage);
          }
          if (!isEmptyArray(response.data.infos)) {
            response.data.infos.map((info) => msg_List.push(info.messageDescription));
          }
        }
        if (
          !isEmpty(response.data.invoicePageList) &&
          isEmptyArray(response.data.invoicePageList.invoices)
        ) {
          if (!isEmptyArray(response.data.errors)) {
            response.data.errors.map((error) => msg_List.push(error.messageDescription));
            notify(TOAST_ERROR, msg_List.toString());
          } else {
            notify(TOAST_WARN, "No Data Found");
          }
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    isInvoiceLoadedRef.current = true;
    stopLoadingWhenBothDone();
  };
 const toggleFullscreen = () => {
    setFullscreen(!isFullscreen);
    if (!isFullscreen) {
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      document.removeEventListener("keydown", handleEscapeKey);
    }
  };
  const handleEscapeKey = (event) => {
    if (event.key === "Escape") setFullscreen(false);
  };
  const generateReport = (type, code) => {
    const request = new RestEntityPrintRequest();
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.entityCode = code;
    request.reportBean = reportBean;
    service(token, "generateSalesOrderPrintReport", request, handleReportResponse, errorCallBack);
  };

  const getReceiptsDetails = (code) => {
    setIsLoading(true);
    const request = new RestReadRequest();
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.code = code;
    service(token, "readSalesOrder", request, handleSalesOrderDetailsResponse, errorCallBack);
  };

  // ── Button handlers ──
  const ExecuteHandler = () => {

    // use setTimeout so criteriaRef is updated before loadPage reads it
    setTimeout(() => loadPage(1), 0);
  };

  const buttonHandler = () => ExecuteHandler();
  // const loadFirst    = () => loadPage(1);
  // const loadLast     = () => loadPage(maxPage);
  // const loadPrevious = () => { if (page > 1) loadPage(parseInt(page) - 1); };
  // const loadNext     = () => { if (maxPage > page) loadPage(parseInt(page) + 1); };

  const PDFHandler        = (code) => {
    if (SecurityAccessManager.SalesOrderMaintenancePDF_Report_IsAccessible()) {
      setIsLoading(true);
      generateReport(1, code);
    } else { setIsAccessible(true); }
  };
  const MoreOptionHandler = (code) => getReceiptsDetails(code);
  const openModal         = (code) => getReceiptsDetails(code);
  const closeModal        = () => setIsShowModal(false);
  const onClose           = () => setIsAccessible(false);

  const ResetHandler = () => {
    setDataList([]);
    setInvDataList([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setCustomerCode("");
  
    setFocus();
    asignDefault();
  };

  const listViewHandler = () => setView(1);
  const gridViewHandler = () => setView(2);

  const getCaption = (s) => StatusConvertor(3, s);

  // ── Table columns ──
  const Columns = () => {
    const _columns = [];
    _columns.push(new ColumnDefinition().setDetails("SalesOrder", "code", true).setStyleDetails("left", "", "", "wt-4", ""));
    _columns.push(new ColumnDefinition().setDetails("Customer", "customerCode", true).setStyleDetails("left", "", "", "wt-4", ""));
    _columns.push(new ColumnDefinition().setDetails("Name", "customerName", true).setStyleDetails("left", "", "", "wt-3", ""));
    _columns.push(new ColumnDefinition().setDetails("ShipTo", "shipToCode", true).setStyleDetails("left", "10", "", "wt-3", ""));
    _columns.push(new ColumnDefinition().setDetails("Date", "createdDate", true).setStyleDetails("left", "10", "", "wt-3", ""));
    _columns.push(new ColumnDefinition().setDetails("orderStatus", "orderStatus", true).setStyleDetails("left", "", "", "wt-3", "").setStatusDetails(true, getCaption));
    // _columns.push(new ColumnDefinition().setDetails("", "code", true).setStyleDetails("right", "", "", "wt-3", "").setClickDetails(false, true, PDFHandler, <PDFICON />));
    // _columns.push(new ColumnDefinition().setDetails("", "code", true).setStyleDetails("right", "", "", "wt-3", "").setClickDetails(false, true, MoreOptionHandler, <MOREOPTIONICON />));
    return _columns;
  };


  const InvColumns = () => {
    const _columns = new Array();
    _columns.push(new ColumnDefinition().setDetails("Inv#", "code", true).setStyleDetails("left", "", "", "wt-4", "wt-4"));
    _columns.push(new ColumnDefinition().setDetails("S.O#", "salesOrderNumber", true).setStyleDetails("left", "", "", "wt-4", "wt-4"));
    _columns.push(new ColumnDefinition().setDetails("Status", "invoiceStatus", true).setStyleDetails("left", "", "", "wt-3", "wt-3").setStatusDetails(true, getCaption));
    _columns.push(new ColumnDefinition().setDetails("Customer", "customerCode", true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("Name", "customerName", true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("Date", "invoiceDate", true, false, true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    // _columns.push(new ColumnDefinition().setDetails("", "code", true).setStyleDetails("right", "", "", "wt-3", "wt-3").setClickDetails(false, true, PDFHandler, <PDFICON />));
    // _columns.push(new ColumnDefinition().setDetails("", "code", true).setStyleDetails("right", "", "", "wt-3", "wt-3").setClickDetails(false, true, MoreOptionHandler, <MOREOPTIONICON />));
    return _columns;
  };;
  // ── Status pill options ──
  const statusOptions = [
    { value: "",         label: "All" },
    { value: "A",         label: "Approved" },
    { value: "U",         label: "UnApproved" },
    { value: "M",         label: "Picked" },
    { value: "L",         label: "Partially Picked" },
    { value: "F",         label: "Invoiced / Finished" },
    { value: "G",         label: "Partially Invoiced" },
    { value: "X",         label: "Cancelled" },
     { value: "H",         label: "Close" },

 
  ];


  return (
    <>
      {isLoading ? <Loader /> : null}

      {/* ── Detail modal ── */}
      <Modal isOpen={isShowModal}  title="Sales Order Lines">
        <SalesOrderDetails salesOrderData={salesOrderData} />
      </Modal>

      {/* ── Toolbar ── */}
      <ToolBar
        title={title}
        button={true}
        // ResetHandler={ResetHandler}
        // ExecuteHandler={ExecuteHandler}
        // isShowPdf={isShowPdf}
        // isShowExcel={isShowExcel}
      />

      {/* {!isMobile && (
        <div className="card-body">
          <div className="row" style={{ flexWrap: "wrap", gap: "8px", alignItems: "flex-end" }}>

           
            {!isEntityUser && (
              <div className="form-group" style={{ flex: "1 1 160px", minWidth: 0 }}>
                <InputTextBox
                  label="Customer"
                  value={criteria.customerCode}
                 name="customerCode"
                  inputRef={inputRef}
                  placeholder="Customer code"
                  onChange={(e) => onCriteriaChange(e)}
                />
              </div>
            )}

          
            <div className="form-group" style={{ flex: "2 1 200px", minWidth: 0 }}>
              <InputTextBox
                label="Search"
                value={criteria.searchName}
                 name="searchName"
                placeholder="Order / name / ship-to…"
       
                   onChange={(e) => onCriteriaChange(e)}
              />
            </div>

            <div className="form-group" style={{ flex: "1 1 140px", minWidth: 0 }}>
              <DatePicker
                type="date"
                label="From"
                   name="fromDate"
                value={criteria.fromDate}
            
                   onChange={(e) => onCriteriaChange(e)}
              />
            </div>

          
            <div className="form-group" style={{ flex: "1 1 140px", minWidth: 0 }}>
              <DatePicker
                type="date"
                label="To"
                 name="toDate"
                value={criteria.toDate}
              
                   onChange={(e) => onCriteriaChange(e)}
              />
            </div>

       
            <div className="form-group" style={{ flex: "0 0 130px" }}>
              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block",
                color: "var(--color-text-secondary, #888)" }}>Status</label>
              <select
                value={criteria.orderStatus}
                name = {"orderStatus"}
            
                   onChange={(e) => onCriteriaChange(e)}
                style={{
                  width: "100%", height: "36px", borderRadius: "6px",
                  border: "1px solid var(--color-border-tertiary, #3a2f70)",
                  background: "var(--color-background-primary, #1f1848)",
                  color: "var(--color-text-primary, #e0d7ff)",
                  padding: "0 8px", fontSize: "13px",
                }}
              >
                {statusOptions.map((o) => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>

         
            <div className="form-group col-fit btn-group" style={{ flexShrink: 0 }}>
              <CustomButton buttonHandler={buttonHandler} disable={disable} buttonRef={buttonRef} label="Fetch" />
              <CustomButton buttonHandler={ResetHandler} label="Reset" />
            </div>

          </div>
        </div>
      )} */}

    
      {/* {isMobile && (
        <div className="module-filter-mobile mobile-filter-bar">
          {!isEntityUser ? (
            <button className="mobile-filter-pill" onClick={() => setIsFilterOpen(true)}>
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none"
                stroke="currentColor" strokeWidth="2.2">
                <line x1="2" y1="4" x2="14" y2="4" />
                <line x1="4" y1="8" x2="12" y2="8" />
                <line x1="6" y1="12" x2="10" y2="12" />
              </svg>
              Filters
             
            </button>
          ) : (
            <button className="mobile-filter-pill" onClick={() => setIsFilterOpen(true)}>
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none"
                stroke="currentColor" strokeWidth="2.2">
                <line x1="2" y1="4" x2="14" y2="4" />
                <line x1="4" y1="8" x2="12" y2="8" />
                <line x1="6" y1="12" x2="10" y2="12" />
              </svg>
              Filters
           
            </button>
          )}
          <div style={{ display: "flex", gap: "8px" }}>
            <button className="mobile-action-btn" onClick={buttonHandler}>Fetch</button>
            <button className="mobile-action-btn outline" onClick={ResetHandler}>Reset</button>
          </div>
        </div>
      )} */}

    
      {/* {isMobile && (
        <div className="module-filter-mobile" style={{ flexDirection: "column", width: "100%" }}>


       
          {isFilterOpen && (
            <div className="mobile-filter-overlay" onClick={() => setIsFilterOpen(false)} />
          )}

       
          <div className={`mobile-filter-sheet${isFilterOpen ? " is-open" : ""}`}>
            <div className="mobile-sheet-handle" />

         
            <div className="mobile-sheet-header">
              <span className="mobile-sheet-title">Filters</span>
              <div className="mobile-sheet-header-actions">
                <button className="mobile-sheet-clear" onClick={() => {
                asignDefault()
                }}>Clear all</button>
                <button className="mobile-sheet-close" onClick={() => setIsFilterOpen(false)}>×</button>
              </div>
            </div>

         
            <div className="mobile-sheet-body">

            
              <div className="mobile-filter-row">
                <span className="mobile-filter-label">Customer</span>
                <InputTextBox
                  value={criteria.customerCode}
                  name="customerCode"
                  placeholder="Enter customer code"
                  disable={isEntityUser}
                     onChange={(e) => onCriteriaChange(e)}
                
                />
              </div>

            
              <div className="mobile-filter-row">
                <span className="mobile-filter-label">Search</span>
                <InputTextBox
                  value={criteria.searchName}
                    name="searchName"
                  placeholder="Order / name / ship-to…"
               
                  onChange={(e) => onCriteriaChange(e)}
                />
              </div>

            
              <div className="mobile-filter-row">
                <span className="mobile-filter-label">Date Range</span>
                <div className="mobile-date-grid">
                  <DatePicker
                    type="date"
                    label="From"
                     name="fromDate"
                    value={criteria.fromDate}
              
                         onChange={(e) => onCriteriaChange(e)}
                  />
                  <DatePicker
                    type="date"
                    label="To"
                     name="toDate"
                    value={criteria.toDate}
                   
                            onChange={(e) => onCriteriaChange(e)}
                  />
                </div>
              </div>

              <div className="mobile-filter-row">
                <span className="mobile-filter-label">Status</span>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
               
                  {statusOptions.map((o) => (
  <button
    key={o.value}
    className={`mobile-status-pill${criteria.orderStatus === o.value ? " active" : ""}`}
    onClick={() =>
      onCriteriaChange({
        target: {
          name: "orderStatus",
          value: o.value,
        },
      })
    }
  >
    {o.label}
  </button>
))}
                </div>
              </div>

            </div>

            <button className="mobile-sheet-apply" onClick={() => {
              setIsFilterOpen(false);
             
              setTimeout(() => loadPage(1), 0);
            }}>
              Apply Filters
            </button>
          </div>

        </div>
      )} */}

      {/* ── Pagination ── */}
      {/* {!isEmptyArray(dataList) && (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      )} */}
     

      {/* ── View toggle ── */}
      {!isEmptyArray(dataList) && (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      )}

      


      {/* ── Results table / card list ── */}

        <div className="card-body">
  {/* <div className={`header_div table-wrap ${isFullscreen ? "full-screen" : ""}`}> */}
        <div>
        <div className="list-wrap_v1">
      {!isEmptyArray(dataList) && (
        <div className="data-sections">

          <section className="data-section">
            <header className="data-section-header">
              <h2 className="data-section-title">Sales Order Details</h2>
            </header>
            <div className={`data-section-body${view === 2 ? " data-section-body-mobile" : ""}`}>
              {view === 1 ? (
                <CustomTable
                  columns={Columns}
                  data={dataList.slice(0, 5)}
                  isShowFullScreen={true}
                />
              ) : (
                <MobileCardTable
                  columns={Columns()}
                  data={dataList.slice(0, 5)}
                  codeAccessor="code"
                  // subAccessor="customerName"
                  // dateAccessor="createdDate"
                  // statusAccessor="orderStatus"
                  // onPDF={(row) => PDFHandler(row.code)}
                  // onMoreOption={(row) => MoreOptionHandler(row.code)}
                />
              )}
            </div>
          </section>
   


         

        </div>

       
      )}
{!isEmptyArray(invdataList) && (
        <div className="data-sections">

          
   

     <section className="data-section">
            <header className="data-section-header">
              <h2 className="data-section-title">Invoice Details</h2>
            </header>
            <div className={`data-section-body${view === 2 ? " data-section-body-mobile" : ""}`}>
              {view === 1 ? (
                <CustomTable
                  columns={InvColumns}
                  data={invdataList.slice(0, 5)}
                  isShowFullScreen={true}
                />
              ) : (
                <MobileCardTable
                  columns={InvColumns()}
                  data={invdataList.slice(0, 5)}
                  codeAccessor="code"
                  // subAccessor="customerName"
                  // dateAccessor="createdDate"
                  // statusAccessor="orderStatus"
                  // onPDF={(row) => PDFHandler(row.code)}
                  // onMoreOption={(row) => MoreOptionHandler(row.code)}
                />
              )}
            </div>
          </section>
         

        </div>

       
      )}
</div>
</div>
   </div>
      
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}